import "../builds/tailwind.css";
import "../css/app.css";

window.htmx = require('htmx.org');

import "./assistant.js";
import "./client_privacy.js";
import "./client_search.js";
import "./find_clients_filters.js";
import "./library_filters.js";
import "./resources.js";
import "./clinician_licensing.js";
import "./hanko_login.js";
import "./hanko_mfa_setup.js";
import "./hanko_password.js";

let Hooks = {};

// wait for some external scripts to load
window.waitFor = (condition, callback) => {
  if (condition()) {
    callback();
  } else {
    setTimeout(() => {
      window.waitFor(condition, callback);
    }, 100);
  }
};
